export enum GATE_CATALOG_ITEM_TYPES {
  MANUFACTURER = "MANUFACTURER",
  MAKE = "MAKE",
  ARTICLE = "ARTICLE",
}
